import React from 'react';
import { componentTypes } from '@white-nl/instantsearch-components';

export default function Loading({ additionalData }: componentTypes.LoadingProps) {
  const { hitsPerPage } = additionalData;

  return (
    <>
      {[...Array(hitsPerPage).keys()].map((i) => (
        <div className="col-12 col-md-6 col-xl-4" key={i}>
          <div className="card card-partners">
            <div className="card-img-top ratio ratio-3x2" />
            <div className="card-body">
              <div>
                <h2 className="card-title placeholder-glow">
                  <span className="placeholder col-12" />
                </h2>
                <address className="placeholder-glow">
                  <span className="placeholder col-6" />
                  <span className="placeholder col-6" />
                  <span className="placeholder col-6" />
                </address>
              </div>
              <ul className="without-border placeholder-glow pb-4">
                <li className="placeholder col-8" />
                <li className="placeholder col-8" />
                <li className="placeholder col-8" />
              </ul>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}
